import InputField from 'components/fields/InputField';
import MultiSelect from 'components/multipleselectoption/Index';
import ConfirmationModal from 'pages/Common/ConfirmationModal';
import { useState, useEffect } from 'react';
import { RiEyeCloseLine, RiEyeLine } from 'react-icons/ri';
import branchService from 'ApiService/Admin/branchService';

const UpdateDataModal = ({
  updatedData,
  setUpdatedData,
  setShowUpdateModal,
  handleUpdateData,
  title,
  userType = '',
}) => {
  const [showPasswordInput, setShowPasswordInput] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [availableBranches, setAvailableBranches] = useState([]);

  const isPlacementUser = userType === 'Placement';

  useEffect(() => {
    if (isPlacementUser) {
      fetchBranches();
    }
  }, [isPlacementUser]);

  const fetchBranches = async () => {
    try {
      const response = await branchService.getAllBranches();
      if (response?.data?.allBranches) {
        const branchList = response.data.allBranches.map((b) => ({
          value: b._id,
          label: b.name || b.Name,
        }));
        setAvailableBranches(branchList);
      }
    } catch (error) {
      console.error('Error fetching branches:', error);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowConfirmation(true);
  };

  const handleConfirm = async () => {
    await handleUpdateData(new Event('submit'));
    setShowConfirmation(false);
  };

  const handleRoleChange = (e) => {
    const newRole = e.target.value;
    setUpdatedData({
      ...updatedData,
      hrRole: newRole,
      allPermission: newRole === 'jrhr' ? updatedData.allPermission : false,
      branches:
        newRole === 'headhr' ||
        (newRole === 'jrhr' && updatedData.allPermission)
          ? []
          : updatedData.branches,
    });
  };

  const handleAllPermissionToggle = (e) => {
    const checked = e.target.checked;
    setUpdatedData({
      ...updatedData,
      allPermission: checked,
      branches: checked ? [] : updatedData.branches,
    });
  };

  const handleBranchesChange = (selectedLabels) => {
    const selected = availableBranches.filter((b) =>
      selectedLabels.includes(b.label)
    );
    setUpdatedData({
      ...updatedData,
      branches: selected.map((b) => b.value),
    });
  };

  const currentBranches =
    updatedData?.branches?.map((b) => {
      if (typeof b === 'string') {
        const found = availableBranches.find((ab) => ab.value === b);
        return found ? found.label : b;
      }
      return b?.name || b?.label || '-';
    }) || [];

  return (
    <div className="bg-black fixed inset-0 z-10 flex items-center justify-center bg-opacity-50">
      <div className="relative mx-4 max-h-[90vh] w-full max-w-md overflow-y-auto rounded-lg bg-white p-4 text-brand-900 shadow-lg dark:bg-navy-800 md:mx-0 md:p-8">
        <button
          type="button"
          onClick={() => setShowUpdateModal(false)}
          className=" absolute right-2 top-2 h-10 w-8 rounded-full text-3xl text-brand-900 transition duration-200 dark:text-brand-900 dark:text-navy-200"
        >
          &times;
        </button>
        <h2 className="mb-4 text-lg font-medium text-navy-800 dark:text-navy-200">
          {title}
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <InputField
              label="Name"
              type="text"
              value={updatedData?.name || ''}
              onChange={(e) =>
                setUpdatedData({
                  ...updatedData,
                  name: e.target.value,
                })
              }
              className="block w-full rounded-md border-none border-gray-300 shadow-sm outline-none sm:text-sm"
            />
          </div>
          <div className="mb-4">
            <InputField
              label="Email"
              type="email"
              value={updatedData?.email || ''}
              onChange={(e) =>
                setUpdatedData({
                  ...updatedData,
                  email: e.target.value,
                })
              }
              className="mt-1 block w-full rounded-md border-none border-gray-300 shadow-sm outline-none sm:text-sm"
            />
          </div>
          <div className="mb-4">
            <InputField
              label="Contact"
              type="number"
              value={updatedData?.contact || ''}
              onChange={(e) =>
                setUpdatedData({
                  ...updatedData,
                  contact: e.target.value,
                })
              }
              className="mt-1 block w-full rounded-md border-none border-gray-300 shadow-sm outline-none sm:text-sm"
            />
          </div>

          {isPlacementUser && (
            <>
              <div className="mb-4">
                <label className="mb-2 block text-sm font-bold text-navy-700 dark:text-white">
                  HR Role <span className="text-red-500">*</span>
                </label>
                <select
                  value={updatedData?.hrRole || 'hr'}
                  onChange={handleRoleChange}
                  className="w-full rounded-xl border border-gray-300 bg-white px-4 py-2 text-sm text-navy-700 focus:border-brand-500 focus:outline-none dark:border-gray-600 dark:bg-gray-800 dark:text-white"
                >
                  <option value="hr">HR (Regular)</option>
                  <option value="jrhr">JR HR</option>
                  <option value="headhr">Head HR</option>
                </select>
              </div>

              {updatedData?.hrRole === 'jrhr' && (
                <div className="mb-4 flex items-center">
                  <label className="relative inline-flex cursor-pointer items-center">
                    <input
                      type="checkbox"
                      checked={updatedData?.allPermission || false}
                      onChange={handleAllPermissionToggle}
                      className="peer sr-only"
                    />
                    <div className="peer h-6 w-11 rounded-full bg-gray-200 after:absolute after:left-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:bg-brand-500 peer-checked:after:translate-x-full peer-checked:after:border-white peer-focus:outline-none dark:border-gray-600 dark:bg-gray-700 dark:peer-checked:bg-brand-500"></div>
                    <span className="ml-3 text-sm font-medium text-navy-700 dark:text-white">
                      All Permissions (Full Access)
                    </span>
                  </label>
                </div>
              )}

              {updatedData?.hrRole !== 'headhr' &&
                !(
                  updatedData?.hrRole === 'jrhr' && updatedData?.allPermission
                ) && (
                  <div className="mb-4">
                    <label className="mb-2 block text-sm font-bold text-navy-700 dark:text-white">
                      Select Branches
                    </label>
                    <MultiSelect
                      options={availableBranches.map((b) => b.label)}
                      selected={currentBranches}
                      onChange={handleBranchesChange}
                    />
                  </div>
                )}
            </>
          )}

          <div className="mb-4">
            <button
              type="button"
              onClick={() => setShowPasswordInput(!showPasswordInput)}
              className="text-blue-500 hover:underline"
            >
              {showPasswordInput
                ? ' Hide Password InputField'
                : ' Update Password'}
            </button>
          </div>

          {showPasswordInput && (
            <div className="relative mb-4">
              <InputField
                label="Password"
                type={showPassword ? 'text' : 'password'}
                onChange={(e) =>
                  setUpdatedData({
                    ...updatedData,
                    password: e.target.value,
                  })
                }
                className="mt-1 block w-full rounded-md border border-gray-300  shadow-sm outline-none focus:ring focus:ring-indigo-300 sm:text-sm"
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 -translate-y-1/2 transform text-gray-800 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? (
                  <RiEyeLine size={18} />
                ) : (
                  <RiEyeCloseLine size={18} />
                )}
              </button>
              <p className="mt-2 text-sm text-gray-600">
                You are updating the user's password
              </p>
            </div>
          )}

          <div className="flex justify-end">
            <button
              type="submit"
              className="w-40 rounded-xl bg-brand-500 py-3 pl-2.5 pr-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
            >
              Update
            </button>
          </div>
        </form>
      </div>
      <ConfirmationModal
        isOpen={showConfirmation}
        onClose={() => setShowConfirmation(false)}
        onConfirm={handleConfirm}
        title="Confirm Update"
        message={`Are you sure you want to update ${updatedData?.name}'s details?`}
        confirmText="Update"
        cancelText="Cancel"
        icon="info"
      />
    </div>
  );
};

export default UpdateDataModal;
